module.exports = __webpack_public_path__ + "img/t3.3971cc59.png";